import React, { FunctionComponent } from "react";
import Image from "next/image";
import Link from "next/link";
import { AssetDetails } from "contentful";

import {
  IBlog,
  IBlogFields,
  IBlogTagFields,
} from "@/types/generated/contentful";

type Props = {
  content: IBlog;
  nav?: boolean;
  leadingTile?: boolean;
  tabIndex?: number;
};

export const BlogPostTile: FunctionComponent<Props> = ({
  content,
  nav = false,
  leadingTile = false,
  tabIndex = 0,
}) => {
  const { image, title, summary, slug, tags } = content.fields as IBlogFields;
  return (
    <Link
      prefetch={false}
      tabIndex={tabIndex}
      href={`/insights/${slug}`}
      className={`flex h-full flex-col rounded-lg border border-gray-200 ${nav ? "" : "shadow-lg"}`}
    >
      <Image
        src={`https:${image.fields.file?.url}`}
        alt={image.fields.description as string}
        width={(image.fields.file?.details as AssetDetails).image?.width}
        height={(image.fields.file?.details as AssetDetails).image?.height}
        className={`rounded-t-lg ${leadingTile ? "" : "h-48"}`}
        style={{
          objectFit: "cover",
        }}
      />
      <div
        className={`flex flex-1 flex-col gap-2 rounded-b-lg p-4 ${
          nav ? "bg-gray-50" : "bg-white"
        }`}
      >
        {!nav && tags && tags.length > 0 && (
          <div className="w-fit rounded-md bg-primary p-1 text-xs text-white">
            {(tags[0].fields as IBlogTagFields).title}
          </div>
        )}
        <span className="flex font-medium">{title}</span>
        <span className="line-clamp-4 font-light">{summary}</span>
        <span className="flex w-full flex-1 items-end text-primary underline">
          Read more
        </span>
      </div>
    </Link>
  );
};
